"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const menuProvider_1 = require("../../../menu/src/interfaces/menuProvider");
const emptyMenuItem_1 = require("../../../menu/src/default/emptyMenuItem");
let ButtonMenuComponent = 
/**
 * Base component for the ButtonMenu
 * @class ButtonMenuComponent
 * @classdesc Base component for the ButtonMenu
 * @author insite-gmbh
 */
class ButtonMenuComponent {
    /**
     * constructor.
     * @param {IMenuProvider} _menuProvider The menu provider is the service for the button menu, it is used to get the menu and
     * also to invoke the commands.
    */
    constructor(_menuProvider) {
        this._menuProvider = _menuProvider;
        this.lines = [];
    }
    get numberOfLines() {
        return this.lines != null ? this.lines.length : 0;
    }
    /**
     * This method will be called when the component is initializing
     * @method ngOnInit
     */
    ngOnInit() {
        this._subscription = this._menuProvider.subscribeToEntriesFor(null).subscribe(result => {
            this.lines = []; //Empty the array
            this.lines.push(this.createEmptyMenu(result));
            this.lines.push(result);
        });
    }
    /**
     * This method will be called when the component was destroyed
     * @method ngOnDestroy
     */
    ngOnDestroy() {
        if (this._subscription != null)
            this._subscription.unsubscribe();
        if (this._submenuSubscription != null)
            this._submenuSubscription.unsubscribe();
    }
    /**
     * This method will we called from the menu line to notify the menu when a selection was changed.
     * @method onSelected
     * @param {IMenuItem} parent Current selected parent menu item.
     */
    onSelected(parent) {
        if (this._submenuSubscription != null)
            this._submenuSubscription.unsubscribe();
        this._submenuSubscription = this._menuProvider.subscribeToEntriesFor(parent).subscribe(result => {
            this.lines = this.lines.reverse();
            this.lines.pop();
            this.lines.push(result);
            this.lines = this.lines.reverse();
        });
    }
    /**
     * This methods will get called if no main menu was selected, so it will generate a dummy submenu line.
     * @method registerEvents
     * @param {Array<IMenuItem>} mainLine The main menu
     */
    createEmptyMenu(mainLine) {
        let result = new Array();
        if (mainLine != null && mainLine.length > 0) {
            let first = mainLine[0];
            for (let i = 0; i < mainLine.length; i++) {
                result[i] = new emptyMenuItem_1.EmptyMenuItem(i, first);
            }
        }
        return result;
    }
};
ButtonMenuComponent = __decorate([
    core_1.Component({
        selector: 'button-menu',
        templateUrl: './@inax/buttonMenuUi/src/buttonMenu/buttonMenu.component.html',
        styleUrls: ['./@inax/buttonMenuUi/src/buttonMenu/buttonMenu.component.css']
    }),
    __param(0, core_1.Inject(menuProvider_1.IMENUPROVIDERSERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object])
], ButtonMenuComponent);
exports.ButtonMenuComponent = ButtonMenuComponent;
